export const steps = {
  inputUrl: "inputUrl",
  loading: "loading",
  preview: "preview",
  configureLocations: "configureLocations",
  configureHoverAction: "configureHoverAction",
  configureClickAction: "configureClickAction",
  configurePointerText: "configurePointerText",
  pickTheme: "pickTheme",
  advanced: "advanced",
  SMVPreview: "SMVPreview",
};

export const messageThemeCodeMarkers = {
  begin: `<!-- Begin message container theme code added by Sirv Hotspot Editor, don't edit -->`,
  end: `<!-- End message container theme code added by Sirv Hotspot Editor -->`,
};

export const modals = {
  videoTutorial: "videoTutorial",
  confirmReturnToInputURL: "confirmReturnToInputURL",
  saveDialog: "saveDialog",
  switchAccountDialog: "switchAccountDialog",
  import: "import",
};

export const versions = {
  spin: "spin",
  image: "image",
};

export const activePointerClassName = "smv-hotspot-pointer--active";

export const sidePanelWidth = "400px";
export const floatingMenuWidth = "200px";

export const hoverActions = {
  none: "none",
  tooltip: "tooltip",
};

export const algorithms = {
  spin: "spin",
  manual: "manual",
};

export const hotspotDisplayStates = {
  none: "none",
  normal: "normal", //preview and other step state, always inFrame, also applies to non-current hotspot in location mode
  // configureLocation step states
  approved: "approved", // set by user mouse action
  proposed: "proposed",
  accepted: "accepted",
  hiddenApproved: "hiddenApproved",
  // hiddenProposed: "hiddenProposed",// doens't make sense, in order to be hidden it must be first accepted or approved
  hiddenAccepted: "hiddenAccepted",
  outOfFrameApproved: "outOfFrameApproved",
  outOfFrameProposed: "outOfFrameProposed",
  outOfFrameAccepted: "outOfFrameAccepted",
  outOfFrameHiddenApproved: "outOfFrameHiddenApproved",
  // outOfFrameHiddenProposed: "outOfFrameHiddenProposed", // doens't make sense, in order to be hidden it must be first accepted or approved
  outOfFrameHiddenAccepted: "outOfFrameHiddenAccepted",
  outOfFrameCurrentNormal: "outOfFrameCurrentNormal",
  currentNormal: "currentNormal",
};

export const hotspotLocationEditorId = "hotspot-location-editor";
export const dontShowTutorialStorageKeyName = "dontShowTutorial";

export const staticImageSnippetTypes = {
  Inline: "Inline",
  Script: "Script",
};
